import { render, staticRenderFns } from "./ComparatorTemplate.vue?vue&type=template&id=5ba0749b"
import script from "./ComparatorTemplate.vue?vue&type=script&lang=js"
export * from "./ComparatorTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports